import items from './items';
import store from './store';
import show from './show';
import update from './update';
import destroy from './destroy';

export default {
  items,
  store,
  show,
  update,
  destroy,
};



// WEBPACK FOOTER //
// ./src/app/services/campaign/index.js